export enum PortalAuthority {
  // FUNC
  FUNC__FUNC_VIEW__PAYMENT_DATA = 'FUNC__FUNC_VIEW__PAYMENT_DATA',
  FUNC__FUNC_VIEW__SALE_DATA = 'FUNC__FUNC_VIEW__SALE_DATA',
  FUNC__FUNC_SYNC_MYSQL__PAYMENT_DATA = 'FUNC__FUNC_SYNC_MYSQL__PAYMENT_DATA',

  // PERM
  PERM_SYNC_SALE_DATA = 'PERM_SYNC_SALE_DATA',
  PERM_REQUEST_MODIFICATION_SALE_DATA = 'PERM_REQUEST_MODIFICATION_SALE_DATA',
  PERM_APPROVE_SALE_DATA = 'PERM_APPROVE_SALE_DATA',
  PERM_COMMENT_SALE_DATA = 'PERM_COMMENT_SALE_DATA',
  PERM_UPLOAD_PAYMENT_DATA = 'PERM_UPLOAD_PAYMENT_DATA',
  PERM_RECONCILE_PAYMENT_DATA = 'PERM_RECONCILE_PAYMENT_DATA',
  PERM_CONFIRM_SALE_DATA = 'PERM_CONFIRM_SALE_DATA'
}
